/* ============================================================
   NL Invisible Lift PDP — controller
   Drives both the desktop and mobile DOM copies at once:
   gallery, offer tiers (omr buy-more model: hidden quantity on
   the real product form; the theme's own ATC does the add),
   variant picker, sticky bar, viewers counter, countdown.
   Tier prices are computed from the live variant price with the
   ratio-based Discount / Full price model (currency-safe).
   ============================================================ */
(function () {
  'use strict';

  var state = {
    idx: 0,
    total: 0,
    tier: null,
    sel: [],
    cd: 900,
    data: null
  };

  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function setText(key, value) { $all('[data-nl="' + key + '"]').forEach(function (el) { el.textContent = value; }); }

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = (state.data && state.data.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    if (/no_decimals/.test(fmt)) amount = Math.round(cents / 100).toString();
    if (/comma_separator/.test(fmt)) amount = amount.replace('.', ',');
    return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/g, amount).replace(/<[^>]*>/g, '');
  }

  /* ---------- gallery ---------- */
  function renderGallery() {
    $all('[data-nl-gal-slide]').forEach(function (el) {
      el.classList.toggle('is-on', parseInt(el.getAttribute('data-nl-gal-slide'), 10) === state.idx);
    });
    $all('[data-nl-thumb]').forEach(function (el) {
      var on = parseInt(el.getAttribute('data-nl-thumb'), 10) === state.idx;
      el.classList.toggle('is-on', on);
      if (on && el.parentElement) {
        var strip = el.parentElement;
        var target = el.offsetLeft - (strip.clientWidth - el.clientWidth) / 2;
        strip.scrollLeft = Math.max(0, target);
      }
    });
    setText('gal-now', state.idx + 1);
  }
  function go(n) {
    if (!state.total) return;
    state.idx = ((n % state.total) + state.total) % state.total;
    renderGallery();
  }

  /* ---------- variant resolution ---------- */
  function variantFor(sel) {
    if (!state.data) return null;
    var vs = state.data.variants, i, j, ok;
    for (i = 0; i < vs.length; i++) {
      ok = true;
      for (j = 0; j < sel.length; j++) {
        if (vs[i].opts[j] !== sel[j]) { ok = false; break; }
      }
      if (ok) return vs[i];
    }
    return null;
  }
  function currentVariant() {
    if (!state.data) return null;
    if (!state.data.hasOptions) return state.data.variants[0] || null;
    return variantFor(state.sel);
  }

  /* ---------- offer tiers (price = live variant price × qty, ratio discount) ---------- */
  function tierMath(el, price) {
    var qty = parseInt(el.getAttribute('data-qty'), 10) || 1;
    var disc = parseFloat(el.getAttribute('data-discount')) || 0;
    var full = parseFloat(el.getAttribute('data-full-price')) || 0;
    var cfull = parseFloat(el.getAttribute('data-compare-full')) || 0;
    var cap = (currentVariant() || {}).cap || 0;
    var total = price * qty;
    var final_ = total;
    if (disc > 0 && full > 0) final_ = total - Math.round(total * disc / full);
    var compare = 0;
    if (cfull > 0 && full > 0) compare = Math.round(total * cfull / full);
    else if (total > final_) compare = total;
    else if (cap > price) compare = cap * qty;
    return { qty: qty, final_: final_, compare: compare };
  }
  function renderTiers() {
    var v = currentVariant();
    var price = v ? v.price : 0;
    var selectedQty = 1, selPrice = '', selWas = '', selPct = '', refill = '';
    $all('.nl-tier').forEach(function (el) {
      var m = tierMath(el, price);
      var priceEl = el.querySelector('[data-nl-tile-price]');
      var wasEl = el.querySelector('[data-nl-tile-was]');
      if (priceEl && price) priceEl.textContent = formatMoney(m.final_);
      if (wasEl) {
        if (m.compare > m.final_ && price) {
          wasEl.textContent = formatMoney(m.compare);
          wasEl.style.display = 'block';
        } else {
          wasEl.textContent = '';
          wasEl.style.display = 'none';
        }
      }
      var on = el.getAttribute('data-tier-index') === String(state.tier);
      el.classList.toggle('is-on', on);
      if (on) {
        selectedQty = m.qty;
        refill = el.getAttribute('data-refill') || '';
        if (price) {
          selPrice = formatMoney(m.final_);
          selWas = m.compare > m.final_ ? formatMoney(m.compare) : '';
          selPct = m.compare > m.final_ ? Math.round((1 - m.final_ / m.compare) * 100) : 0;
        }
      }
    });
    if (selPrice) setText('offer-price', selPrice);
    setText('offer-was', selWas);
    setText('save-pct', selPct);
    if (refill) setText('refill', refill);
    $all('[data-nl-qty-input]').forEach(function (i) { i.value = selectedQty; });
  }
  function selectTier(i) { state.tier = String(i); renderTiers(); }

  /* ---------- variant picker (generic options) ---------- */
  function anyAvailableWith(pos, val) {
    var vs = state.data.variants, i, j, ok;
    for (i = 0; i < vs.length; i++) {
      if (!vs[i].available) continue;
      if (vs[i].opts[pos] !== val) continue;
      ok = true;
      for (j = 0; j < state.sel.length; j++) {
        if (j === pos) continue;
        if (state.sel[j] != null && vs[i].opts[j] !== state.sel[j]) { ok = false; break; }
      }
      if (ok) return true;
    }
    return false;
  }
  function renderPicker() {
    if (!state.data) return;
    if (state.data.hasOptions) {
      $all('[data-nl-opt-pos]').forEach(function (el) {
        var pos = parseInt(el.getAttribute('data-nl-opt-pos'), 10);
        var val = el.getAttribute('data-nl-opt-val');
        el.classList.toggle('is-on', state.sel[pos] === val);
        el.classList.toggle('is-off', !anyAvailableWith(pos, val));
      });
      $all('[data-nl-opt-label]').forEach(function (el) {
        var pos = parseInt(el.getAttribute('data-nl-opt-label'), 10);
        el.textContent = state.sel[pos] || '';
      });
      var names = state.data.optionNames || [];
      for (var p = 0; p < names.length; p++) {
        if (String(names[p]).toLowerCase() === 'size') {
          var fit = state.data.sizeFits && state.data.sizeFits[state.sel[p]];
          setText('fits', fit ? 'Fits: ' + fit : '');
        }
      }
    }
    // keep the real product forms in step with the picked variant
    var v = currentVariant();
    if (v) {
      $all('[data-nl-id-input]').forEach(function (i) { i.value = v.id; });
      $all('.nl-atc').forEach(function (b) { b.disabled = !v.available; });
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }
  }
  function jumpToVariantMedia() {
    var v = currentVariant();
    if (v && typeof v.media === 'number' && v.media >= 0 && v.media < state.total) go(v.media);
  }

  /* ---------- sticky bar ---------- */
  function visibleAtc() {
    var els = $all('.nl-atc-main');
    for (var i = 0; i < els.length; i++) {
      if (els[i].offsetParent !== null) return els[i];
    }
    return null;
  }
  function syncSticky() {
    var atc = visibleAtc();
    if (!atc) return;
    var on = atc.getBoundingClientRect().bottom < 0;
    $all('.nl-sticky').forEach(function (el) { el.classList.toggle('is-on', on); });
  }

  /* ---------- timers ---------- */
  function startTimers() {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var d = new Date(); d.setDate(d.getDate() + 4);
    setText('day', days[d.getDay()]);
    setInterval(function () {
      setText('viewers', Math.max(6, 10 + Math.floor(Math.random() * 9) - 3));
    }, 5200);
    setInterval(function () {
      state.cd = state.cd > 0 ? state.cd - 1 : 900;
      var m = Math.floor(state.cd / 60), s = state.cd % 60;
      setText('clock', m + ':' + (s < 10 ? '0' : '') + s);
    }, 1000);
  }

  /* ---------- init ---------- */
  function init() {
    var dataEl = document.getElementById('nl-il-data');
    if (!dataEl) return;
    try { state.data = JSON.parse(dataEl.textContent); } catch (e) { state.data = null; }

    state.total = $all('.nl-il-desk [data-nl-gal-slide]').length;

    var firstSel = document.querySelector('.nl-tier[data-tier-selected="true"]') || document.querySelector('.nl-tier');
    state.tier = firstSel ? firstSel.getAttribute('data-tier-index') : null;

    if (state.data && state.data.defaultSel) {
      state.sel = state.data.defaultSel.slice();
    }

    document.addEventListener('click', function (ev) {
      var t = ev.target.closest ? ev.target.closest('[data-nl-action],[data-nl-thumb],[data-nl-opt-pos],.nl-tier') : null;
      if (!t) return;
      var action = t.getAttribute('data-nl-action');
      if (action === 'gal-prev') { go(state.idx - 1); return; }
      if (action === 'gal-next') { go(state.idx + 1); return; }
      if (t.hasAttribute('data-nl-thumb')) { go(parseInt(t.getAttribute('data-nl-thumb'), 10)); return; }
      if (action === 'tier-first') {
        var first = document.querySelector('.nl-tier');
        if (first) selectTier(first.getAttribute('data-tier-index'));
        var atc = visibleAtc();
        if (atc) atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (t.classList.contains('nl-tier')) { selectTier(t.getAttribute('data-tier-index')); return; }
      if (t.hasAttribute('data-nl-opt-pos')) {
        state.sel[parseInt(t.getAttribute('data-nl-opt-pos'), 10)] = t.getAttribute('data-nl-opt-val');
        renderPicker();
        renderTiers();
        jumpToVariantMedia();
        return;
      }
    });

    window.addEventListener('scroll', syncSticky, { passive: true });
    window.addEventListener('resize', syncSticky);

    renderGallery();
    renderPicker();
    renderTiers();
    // deep link: land on the ?variant= image like the theme's main-product does
    if (/[?&]variant=/.test(window.location.search)) jumpToVariantMedia();
    startTimers();
    syncSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
